const runtimeConfig =
  typeof window !== 'undefined' && window.__APP_CONFIG__
    ? window.__APP_CONFIG__
    : {};

const processEnv =
  typeof process !== 'undefined' && process.env
    ? process.env
    : {};

const PROFILE_STORAGE_KEY = 'app_runtime_profile';

const getBrowserSearchParam = (name) => {
  if (typeof window === 'undefined') return '';

  try {
    return new URLSearchParams(window.location.search).get(name) || '';
  } catch (error) {
    return '';
  }
};

const getStoredProfile = () => {
  if (typeof window === 'undefined' || !window.localStorage) return '';

  try {
    return window.localStorage.getItem(PROFILE_STORAGE_KEY) || '';
  } catch (error) {
    return '';
  }
};

const persistSelectedProfile = (profileName) => {
  if (!profileName || typeof window === 'undefined' || !window.localStorage) return;

  try {
    window.localStorage.setItem(PROFILE_STORAGE_KEY, profileName);
  } catch (error) {
    // Ignore storage failures in private mode / restricted browsers
  }
};

const getFirstNonEmptyString = (...values) =>
  values.find((value) => typeof value === 'string' && value.trim().length > 0) || '';

const normalizeBaseUrl = (value) => value.replace(/\/+$/, '');

const runtimeProfiles =
  runtimeConfig.profiles && typeof runtimeConfig.profiles === 'object'
    ? runtimeConfig.profiles
    : {};

const selectedProfileName = getFirstNonEmptyString(
  getBrowserSearchParam('profile'),
  getStoredProfile(),
  runtimeConfig.defaultProfile
);

if (selectedProfileName) {
  persistSelectedProfile(selectedProfileName);
}

const selectedProfileConfig =
  selectedProfileName && runtimeProfiles[selectedProfileName]
    ? runtimeProfiles[selectedProfileName]
    : {};

const effectiveRuntimeConfig = {
  ...runtimeConfig,
  ...selectedProfileConfig
};

export const ACTIVE_PROFILE = selectedProfileName || '';
export const AVAILABLE_PROFILES = Object.keys(runtimeProfiles);

const developmentApiUrl =
  processEnv.NODE_ENV === 'development'
    ? 'http://localhost:3001'
    : '';

export const API_URL = normalizeBaseUrl(
  getFirstNonEmptyString(
    developmentApiUrl,
    effectiveRuntimeConfig.VITE_API_URL,
    effectiveRuntimeConfig.REACT_APP_API_URL,
    processEnv.VITE_API_URL,
    processEnv.REACT_APP_API_URL
  )
);

export const ASSET_BASE_URL = API_URL.replace(/\/api$/i, '');

export const buildApiUrl = (path = '') => {
  if (!path) return API_URL;
  if (/^https?:\/\//i.test(path)) return path;

  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return API_URL ? `${API_URL}${normalizedPath}` : normalizedPath;
};

export const buildAssetUrl = (path = '') => {
  if (!path) return ASSET_BASE_URL;
  if (/^https?:\/\//i.test(path)) return path;

  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return ASSET_BASE_URL ? `${ASSET_BASE_URL}${normalizedPath}` : normalizedPath;
};

export const buildUploadUrl = (path = '') => {
  if (!path) return null;

  if (/^https?:\/\//i.test(path)) return path;
  if (path.startsWith('/uploads')) return buildAssetUrl(path);

  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return buildAssetUrl(`/uploads${normalizedPath}`);
};
